import React from 'react';

const Footer = () => {
    return (
        <footer className="py-4 px-6 border-t border-border/40 bg-card/30 mt-auto">
            <div className="text-center text-sm text-muted-foreground">
                © 2025 Elara CMS – All Rights Reserved. Elara CMS is a proprietary software product developed and owned by{' '}
                <a 
                    href="https://www.tricona.com" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="text-primary hover:underline font-medium"
                >
                    Tricona
                </a>
                .
            </div>
        </footer>
    );
};

export default Footer;
